import { useLocation } from 'react-router-dom';

import { ROUTES } from 'constants/routes.constant';

import MenuElement from 'components/menu/menuElement/MenuElement';

import { isRoute } from 'utils/route.utils';

import styles from './Header.module.scss';

interface HeaderNavigationProps {
  /** Whether to show disabled message for map page */
  mapPageDisabled: boolean;
  /** URL to navigate to for map page */
  mapUrl: string;
  /** Callback to show disabled message */
  onMapDisabledClick: () => void;
  navTextClassName?: string;
  activeNavTextClassName?: string;
  variant?: 'default' | 'referral';
}

/**
 * HeaderNavigation renders the main navigation menu items.
 *
 * Used in both desktop and mobile headers with consistent styling.
 * Handles special cases like disabled map link.
 */
const HeaderNavigation = ({
  mapPageDisabled,
  mapUrl,
  onMapDisabledClick,
  navTextClassName = styles['nav-text'],
  activeNavTextClassName = styles['nav-text--active'],
  variant = 'default',
}: HeaderNavigationProps) => {
  const location = useLocation();

  const isEventsRoute = isRoute({ pathname: location.pathname, routes: [ROUTES.EVENTS], trailingSlash: true });

  return (
    <>
      <li>
        <MenuElement
          title="Games"
          active={location.pathname === ROUTES.GAMES}
          link={ROUTES.GAMES}
          textClassName={[navTextClassName, styles['nav-text__staking']].join(' ')}
          activeTextClassName={activeNavTextClassName}
        />
      </li>
      <li>
        <MenuElement
          title="Dash"
          active={location.pathname === ROUTES.DASHBOARD}
          link={ROUTES.DASHBOARD}
          textClassName={navTextClassName}
          activeTextClassName={activeNavTextClassName}
        />
      </li>
      <li>
        <MenuElement
          title="Bid2Earn"
          active={location.pathname.startsWith(ROUTES.BID2EARN)}
          link={ROUTES.BID2EARN}
          textClassName={navTextClassName}
          activeTextClassName={activeNavTextClassName}
        />
      </li>

      <li>
        <MenuElement
          title="Marketplace"
          active={location.pathname === ROUTES.MARKET}
          link={ROUTES.MARKET}
          textClassName={navTextClassName}
          activeTextClassName={activeNavTextClassName}
        />
      </li>
      <li>
        <MenuElement
          title="Staking"
          active={location.pathname === ROUTES.PERIODICAL_STAKING}
          link={ROUTES.PERIODICAL_STAKING}
          textClassName={navTextClassName}
          activeTextClassName={activeNavTextClassName}
          variant={variant}
        />
      </li>
      <li>
        {/* Store route displayed as "Shop" in navigation */}
        <MenuElement
          title="Shop"
          active={location.pathname === ROUTES.STORE}
          link={ROUTES.STORE}
          textClassName={navTextClassName}
          activeTextClassName={activeNavTextClassName}
        />
      </li>
      <li>
        <MenuElement
          title="WORLD NFT"
          active={location.pathname === `${ROUTES.TRADING_EVENT}/world-nft`}
          link={`${ROUTES.TRADING_EVENT}/world-nft`}
          textClassName={navTextClassName}
          activeTextClassName={activeNavTextClassName}
        />
      </li>
      <li>
        <MenuElement
          title="Events"
          active={isEventsRoute}
          link={ROUTES.EVENTS}
          textClassName={navTextClassName}
          activeTextClassName={activeNavTextClassName}
          variant={variant}
        />
      </li>
      <li>
        <MenuElement
          title="VIP"
          active={location.pathname === ROUTES.VIP}
          link={ROUTES.VIP}
          textClassName={navTextClassName}
          activeTextClassName={activeNavTextClassName}
          variant={variant}
        />
      </li>
    </>
  );
};

export default HeaderNavigation;
